var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-row",
    [
      _c(
        "w-col",
        [
          _c(
            "w-card",
            [
              _c("w-card-title", [_vm._v(_vm._s(_vm.$ct("free-lines")))]),
              _c(
                "w-card-content",
                [
                  _c(
                    "w-row",
                    [
                      _c(
                        "w-col",
                        [
                          _c("app-custom-lang-select", {
                            model: {
                              value: _vm.selectedLang,
                              callback: function ($$v) {
                                _vm.selectedLang = $$v
                              },
                              expression: "selectedLang",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "w-sortable",
                {
                  attrs: {
                    items: _vm.lines,
                    "disable-x": "",
                    "keep-in-y": "",
                    tag: "w-list",
                    "target-class": "handle",
                  },
                },
                _vm._l(_vm.lines, function (line, i) {
                  return _c(
                    "w-list-item",
                    { key: i, attrs: { "show-handle": "" } },
                    [
                      _c("w-list-item-text", [
                        _c(
                          "span",
                          { attrs: { "style-off": line.Style.getStyle() } },
                          [_vm._v(_vm._s(line.getText(_vm.selectedLang)))]
                        ),
                        line.Label
                          ? _c("span", { staticClass: "label" }, [
                              _vm._v(_vm._s(line.Label)),
                            ])
                          : _vm._e(),
                      ]),
                      _c(
                        "w-list-item-action",
                        [
                          _c(
                            "w-button",
                            {
                              directives: [
                                {
                                  name: "tooltip",
                                  rawName: "v-tooltip",
                                  value: _vm.$ct(`tooltip.line-edit`),
                                  expression: "$ct(`tooltip.line-edit`)",
                                },
                              ],
                              on: {
                                click: function ($event) {
                                  return _vm.editLine(line)
                                },
                              },
                            },
                            [_c("w-fa", { attrs: { icon: "pen" } })],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "w-list-item-action",
                        [
                          _c(
                            "w-button",
                            {
                              directives: [
                                {
                                  name: "tooltip",
                                  rawName: "v-tooltip",
                                  value: _vm.$ct(`tooltip.style-edit`),
                                  expression: "$ct(`tooltip.style-edit`)",
                                },
                              ],
                              on: {
                                click: function ($event) {
                                  return _vm.editStyle(line)
                                },
                              },
                            },
                            [_c("w-fa", { attrs: { icon: "font" } })],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "w-list-item-action",
                        [
                          _c(
                            "w-button",
                            {
                              directives: [
                                {
                                  name: "tooltip",
                                  rawName: "v-tooltip",
                                  value: _vm.$ct(`tooltip.line-remove`),
                                  expression: "$ct(`tooltip.line-remove`)",
                                },
                              ],
                              staticClass: "danger",
                              on: {
                                click: function ($event) {
                                  return _vm.removeLine(i)
                                },
                              },
                            },
                            [_c("w-fa", { attrs: { icon: "trash" } })],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                }),
                1
              ),
              _c(
                "w-card-actions",
                [
                  _c("w-spacer"),
                  _c(
                    "w-button",
                    {
                      directives: [
                        {
                          name: "tooltip",
                          rawName: "v-tooltip",
                          value: _vm.$ct("tooltip.line-add"),
                          expression: "$ct('tooltip.line-add')",
                        },
                      ],
                      attrs: { flat: "" },
                      on: {
                        click: function ($event) {
                          return _vm.createNew()
                        },
                      },
                    },
                    [_c("w-fa", { attrs: { icon: "plus" } })],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "w-modal",
        { attrs: { value: _vm.toEditLine != null } },
        [
          _vm.toEditLine
            ? _c(
                "app-field-edit",
                {
                  attrs: {
                    value: _vm.toEditLine,
                    "selected-lang": _vm.selectedLang,
                    title: _vm.$ct("editTitle"),
                  },
                  on: {
                    close: function ($event) {
                      _vm.toEditLine = null
                    },
                  },
                },
                [
                  _c(
                    "w-row",
                    { attrs: { slot: "top" }, slot: "top" },
                    [
                      _c(
                        "w-col",
                        { attrs: { xs: "12" } },
                        [
                          _c("w-input", {
                            attrs: { label: _vm.$ct("name"), fancy: "" },
                            model: {
                              value: _vm.toEditLine.Label,
                              callback: function ($$v) {
                                _vm.$set(_vm.toEditLine, "Label", $$v)
                              },
                              expression: "toEditLine.Label",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "w-row",
                    [
                      _c(
                        "w-col",
                        { attrs: { xs: "12" } },
                        [
                          _c("app-select-free-line-placement", {
                            attrs: { label: _vm.$ct("placement"), fancy: "" },
                            model: {
                              value: _vm.toEditLine.Placement,
                              callback: function ($$v) {
                                _vm.$set(_vm.toEditLine, "Placement", $$v)
                              },
                              expression: "toEditLine.Placement",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "w-row",
                    [
                      _c(
                        "w-col",
                        { attrs: { xs: "12", md: "4" } },
                        [
                          _c("w-checkbox", {
                            attrs: {
                              value: !_vm.toEditLine.HideOnDownload,
                              label: _vm.$ct("show-on-download"),
                            },
                            on: {
                              input: function ($event) {
                                _vm.toEditLine.HideOnDownload = !$event
                              },
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "w-col",
                        { attrs: { xs: "12", md: "4" } },
                        [
                          _c("w-checkbox", {
                            attrs: {
                              value: !_vm.toEditLine.HideOnEmailSend,
                              label: _vm.$ct("show-on-email-send"),
                            },
                            on: {
                              input: function ($event) {
                                _vm.toEditLine.HideOnEmailSend = !$event
                              },
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "w-col",
                        { attrs: { xs: "12", md: "4" } },
                        [
                          _c("w-checkbox", {
                            attrs: {
                              value: !_vm.toEditLine.HideOnPrint,
                              label: _vm.$ct("show-on-print"),
                            },
                            on: {
                              input: function ($event) {
                                _vm.toEditLine.HideOnPrint = !$event
                              },
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _c(
        "w-modal",
        { attrs: { value: _vm.toEditStyleLine != null } },
        [
          _vm.toEditStyleLine
            ? _c("app-style-editor", {
                attrs: { value: _vm.toEditStyleLine.Style },
                on: {
                  input: function ($event) {
                    _vm.toEditStyleLine.Style = $event
                  },
                  close: function ($event) {
                    _vm.toEditStyleLine = null
                  },
                },
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }